import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[OnlyNumber]',
    standalone: false,
})
export class OnlyNumberDirective {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
        if (this.isSpecialCommandAllowed(event)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if (event.key === ' ' || isNaN(Number(event.key))) {
            event.preventDefault();
        }
    }

    private isSpecialCommandAllowed(event: KeyboardEvent) {
        let allowed = false;
        if (
            [
                'Backspace',
                'Delete',
                'Tab',
                'Escape',
                'Enter',
                'Return',
                'Home',
                'End',
                'ArrowLeft',
                'ArrowRight',
                'ArrowDown',
                'ArrowUp',
            ].includes(event.key)
        ) {
            allowed = true;
        } else {
            if (event.ctrlKey && ['A', 'C', 'V', 'X', 'a', 'c', 'v', 'x'].includes(event.key)) {
                allowed = true;
            }
        }

        return allowed;
    }
}
